<template>
  <header class="wbs-site__header navbar navbar-expand-lg navbar-dark">
    <router-link to="/" class="navbar-brand text-center"
      >WBSPacs-Manager</router-link
    >
    <ul class="navbar-nav flex-row wbs-site__header-menu">
      <li class="nav-item" v-for="(item, idx) in items" :key="idx">
        <router-link :to="item.route" class="nav-link">
          <i class="mdi" :class="item.icon"></i>
          {{ item.text }}
        </router-link>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto d-flex flex-row menu-rigth">
      <li class="nav-item">
        <a href="javscript:void(0);" class="nav-link" @click="sair">
          <i class="mdi mdi-logout-variant"></i> Sair
        </a>
      </li>
    </ul>
  </header>
</template>
<script>
export default {
  name: "appBarraSuperior",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    async sair() {
      await this.$store.dispatch("autenticacao/logout");
      this.$router.push("autenticacao");
    }
  }
};
</script>
<style lang="scss">
.navbar-brand {
  width: 185px;
}
.menu-rigth {
  align-items: center;
}
</style>
